import { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import styles from './styles.module.scss';
import { cutString, toTitleCase } from '../../utils';
import classNames from 'classnames';

const ImageCarousel = ({
  data,
  name,
  outOfStock = false,
}: {
  data?: string[];
  name: string;
  outOfStock?: boolean;
}) => {
  const _name = name?.length > 20 ? `${cutString(name, 20)}...` : name;
  const swiperRef = useRef<HTMLElement>(null);

  useEffect(() => {
    let elem = swiperRef.current;
    if (elem) {
      elem
        .querySelector('.swiper-button-next')
        ?.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
      elem
        .querySelector('.swiper-button-prev')
        ?.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        });
    }
  }, []);

  if (data?.length) {
    return (
      <div className="w-full h-full">
        <Swiper
          ref={swiperRef as any}
          className="w-full h-full"
          pagination
          navigation
          modules={[Pagination, Navigation]}
          style={
            {
              '--swiper-navigation-color': 'var(--ion-color-secondary)',
              '--swiper-navigation-size': '1.5rem',
            } as any
          }
        >
          {data?.map((url) => (
            <SwiperSlide key={url}>
              <img
                src={url}
                alt=""
                className={"w-full h-full object-cover " + classNames({'filter grayscale':outOfStock})}
                loading="lazy"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }

  return (
    <div className={styles.imageWrapper}>
      <p>{toTitleCase(_name)}</p>
    </div>
  );
};

export default ImageCarousel;
